// src/components/SpaceportSimulator/SpaceportSimulator.js
import { useEffect, useRef, useState } from 'react';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";
import './SpaceportSimulator.scss';
import 'pannellum';
import 'pannellum/build/pannellum.css';
import { useParams, useNavigate, Navigate } from 'react-router-dom';
// Your assets
import imgLaunchpad from '../../images/equi_rocket_1.png'; 
import imgEarth from '../../images/equi_rocket_2.jpg'; 
import imgMoon from '../../images/equi_rocket_3.jpg';  
import imgMars from '../../images/equi_rocket_4.jpg'; 
import imgSpPo1 from '../../images/equi_spaceport_1.jpg'; 
import imgSpPo2 from '../../images/equi_spaceport_2.jpg'; 
import imgSpPo3 from '../../images/equi_spaceport_3.jpg'; 

const BASE_PATH = "/desarrollos/rocha"; 
const SpaceportSimulator = () => {
    const { i18n } = useLingui();
    const navigate = useNavigate();
    const viewerRef = useRef(null);  
    // 1. GET SLUG FROM URL
    const { sceneId } = useParams(); // This grabs "mars" from /simulator/mars

    // 2. DEFINE THE DEFAULT (If user goes to just /simulator)
    const defaultScene = "launchpad";
    

       // --- THE TOPOLOGY (The Graph) ---
    // This defines your world. You can move this to a separate .js file later.
    const scenes = {
        "launchpad": {
            title: t`Launchpad Alpha`,
            image: imgLaunchpad,
            // The "Edges" of the graph
            hotSpots: [
                {
                    pitch: 10, yaw: -75, // Where the arrow is placed in 3D space
                    type: "scene",      // Special type for navigation
                    text: t`Irse de Launchpad`,
                    sceneId: "spaceport1",   // The target Node ID
                    cssClass: "scene-nav-arrow",
                    rotation: 45 
                },
                {
                    pitch: 10, yaw: -30, 
                    type: "scene",     
                    text: t`Ir a ver lanzamiento`,
                    sceneId: "spaceport2",
                    cssClass: "scene-nav-arrow",
                    rotation: 45 
                },
                {
                    pitch: 55, yaw: -15, // Where the arrow is placed in 3D space
                    type: "scene",      // Special type for navigation
                    text: t`Ir a Luna`,
                    sceneId: "luna" ,
                    cssClass: "scene-nav-arrow" 
                },
                {
                    pitch: 55, yaw: 15, // Where the arrow is placed in 3D space
                    type: "scene",      // Special type for navigation
                    text: t`Ir a Marte`,
                    sceneId: "marte",
                    cssClass: "scene-nav-arrow" 
                },
                {
                    pitch: -25, yaw: 0,
                    type: "info",
                    text: t`Motores cohete`,
                    infoData: {
                        title: t`Motores de Cohete Saturno V`,
                        description: t`Aca iria la descripcion de los motores de este cohete etc`,
                        //image: "https://via.placeholder.com/300x150" // Placeholder for now
                    },
                    cssClass: "info-marker" // The circle 'i' style
                }
            ]
        },
          "spaceport1": {
            title: t`Llegando a Launchpad`,
            image: imgSpPo1,
            hotSpots: [
                {
                    pitch: 0, yaw: 0,
                    type: "scene",
                    text: t`Volver al Launchpad`,
                    sceneId: "launchpad",
                    cssClass: "scene-nav-arrow" 
                },
                 {
                    pitch: 0, yaw: 180,
                    type: "scene",
                    text: t`Ir a Campo`,
                    sceneId: "tierra",
                    cssClass: "scene-nav-arrow" 
                }
            ]
        },
          "spaceport2": {
            title: t`Proximo a Launchpad`,
            image: imgSpPo2,
            hotSpots: [
                {
                    pitch: 0, yaw: 0,
                    type: "scene",
                    text: t`Volver al Launchpad`,
                    sceneId: "launchpad",
                    cssClass: "scene-nav-arrow" 
                },
                {
                    pitch: 0, yaw: 180,
                    type: "scene",
                    text: t`Ver lanzamiento`,
                    sceneId: "spaceport3",
                    cssClass: "scene-nav-arrow" 
                }
            ]
        },
          "spaceport3": {
            title: t`Vista Lanzamiento`,
            image: imgSpPo3,
            hotSpots: [
                {
                    pitch: 0, yaw: 45,
                    type: "scene",
                    text: t`Volver al Launchpad`,
                    sceneId: "spaceport2",
                    cssClass: "scene-nav-arrow" 
                }
            ]
        },
        "tierra": {
            title: t`Escena Tierra`,
            image: imgEarth,
            hotSpots: [
                {
                    pitch: 0, yaw: 180,
                    type: "scene",
                    text: t`Volver al Launchpad`,
                    sceneId: "spaceport1",
                    cssClass: "scene-nav-arrow" 
                }
            ]
        },
        "luna": {
            title: t`Escena Luna`,
            image: imgMoon,
            hotSpots: [
                {
                    pitch: 0, yaw: -90,
                    type: "scene",
                    text: t`Volver a Tierra`,
                    sceneId: "launchpad",
                    cssClass: "scene-nav-arrow" 
                }
            ]
        },
        "marte": {
            title: t`Escena Marte`,
            image: imgMars,
            hotSpots: [
                {
                    pitch: 0, yaw: -90,
                    type: "scene",
                    text: t`Volver a Tierra`,
                    sceneId: "launchpad",
                    cssClass: "scene-nav-arrow" 
                }
            ]
        }
    };

    // --- STATE ---
    // Empezamos en el launchpad
    //const [currentSceneId, setCurrentSceneId] = useState("launchpad");
    const [isMapOpen, setIsMapOpen] = useState(false); // para el menu del mapa 
    const [selectedFeature, setSelectedFeature] = useState(null); // para el panel de info
    
    const isValidScene = sceneId && scenes[sceneId];
    const currentScene = isValidScene ? scenes[sceneId] : null;
    // Helper to get current scene data safely
    // const currentScene = scenes[currentSceneId];

    const projectTitle = t`Simulador de Espaciopuerto`;
    
    useEffect(() => {
        document.title = `${projectTitle} - ${t`The Cosmic Shores`}`;
    }, [projectTitle, i18n.locale]);


    // --- THE RENDER ENGINE ---
    useEffect(() => {
        // Destroy existing viewer if it exists (cleanup)
        if (viewerRef.current) {
            viewerRef.current.destroy();
        }
        if (!currentScene) return;

        // Transform our data into Pannellum format
        // We map our custom "hotSpots" to Pannellum's specific format
        const formattedHotspots = currentScene.hotSpots.map(spot => {
            return {
                pitch: spot.pitch,
                yaw: spot.yaw,
                type: spot.type,
                text: spot.text,
                cssClass: spot.cssClass, // Pass the class to Pannellum!
                createTooltipArgs: { 
                    rotation: spot.rotation 
                },
                createTooltipFunc: (hotSpotDiv, args) => {
                    // Check if a rotation was provided (Info spots might not have one)
                    if (args.rotation !== undefined) {
                        hotSpotDiv.style.transform = `rotate(${args.rotation}deg)`;
                    }
                      hotSpotDiv.title = spot.text;
                },
                clickHandlerFunc: (e) => {
                    if (spot.type === 'scene') {
                      //  setCurrentSceneId(spot.sceneId);
                      navigate(`/desarrollos/rocha/${spot.sceneId}`);
                    } else if (spot.type === 'info') {
                        // Open the modal with the data from the config
                        setSelectedFeature(spot.infoData);
                    }}
            };
        });

        // Initialize Viewer
        viewerRef.current = window.pannellum.viewer('panorama-container', {
            type: 'equirectangular',
            panorama: currentScene.image,
            autoLoad: true,
            compass: false, 
            showZoomCtrl: false, 
            showFullscreenCtrl: false, 
            showControls: false,  
            hotSpotDebug: false, // HELPFUL: This prints Pitch/Yaw to console when you click!
            hotSpots: formattedHotspots,
            hfov: 120
        },[sceneId]);

        return () => {
            if (viewerRef.current) {
                viewerRef.current.destroy();
            }
        };
        }, [sceneId]); // Re-run whenever the Node ID changes

    if (!isValidScene) {
        return <Navigate to={`${BASE_PATH}/${defaultScene}`} replace />;
    }
      return (
        <div className='simulador-wrapper'>
            <div id="panorama-container" className="panorama-layer"></div>

            <div className="hud-layer">
                <div className="hud-top-left">
                        <button className="cosmic-btn back-btn" onClick={() => navigate(-1)}>
                            <span className="btn-icon">&larr;</span> 
                        <span className="btn-text">{t` VOLVER`}</span>
                        </button>
                </div>

                {/* Top Center: Location Info */}
                <div className="hud-top-center">
                    <div className="glass-panel">
                        <span className="live-indicator"><Trans>● RENDER</Trans></span>
                        <h2>{currentScene.title}</h2>
                    </div>
                </div>

                {/* Top Right: Map Toggle */}
                <div className="hud-top-right">
                    <button 
                        className={`cosmic-btn map-btn ${isMapOpen ? 'active' : ''}`}
                        onClick={() => setIsMapOpen(!isMapOpen)}
                    >
                        <span className="btn-icon">🗺️</span> 
                        <span className="btn-text">{t` MAPA`}</span>
                    </button>
                </div>
                
                {/* Debug Helper: Remove this later */}
                <div className="hud-bottom">
                  <p><Trans>Arrastrarse para girar. Scroll para ampliar. Click para explorar.</Trans></p>
                   <p><Trans>Sitio: {sceneId}</Trans></p>
                </div>
            </div>
              {selectedFeature && (
                <div className="info-modal-overlay" onClick={() => setSelectedFeature(null)}>
                    {/* stopPropagation prevents closing when clicking INSIDE the card */}
                    <div className="info-modal-card" onClick={(e) => e.stopPropagation()}>
                        <button className="close-modal" onClick={() => setSelectedFeature(null)}>&times;</button>
                        
                        <h3>{selectedFeature.title}</h3>
                        
                        {selectedFeature.image && (
                            <img src={selectedFeature.image} alt={selectedFeature.title} />
                        )}
                        
                        <p>{selectedFeature.description}</p>
                    </div>
                </div>
            )}
              {isMapOpen && (
                <div className="map-overlay">
                    <div className="map-content">
                        <h3><Trans>Mapa del lugar</Trans></h3>
                        <p> [acá iria mapa y botones]</p>
                        <button className='cosmic-btn' onClick={() => setIsMapOpen(false)}>Close</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SpaceportSimulator;

